import { cn } from '@kar-dmp/ignite';

export const OneColumnWrapper = ({ children, className, ...props }) => (
	<div
		{...props}
		className={cn(
			'relative z-[3] flex flex-col items-center justify-start px-4 py-8 md:px-10! md:py-14!',
			className,
		)}
	>
		{children}
	</div>
);

export const StepContainer = ({ children, className, hasTopContent, ...props }) => (
	<div {...props} className={cn('mb-8 w-full md:w-[640px]!', hasTopContent ? 'md:mb-6!' : 'md:mb-14!', className)}>
		{children}
	</div>
);

export const Card = ({ children, className, ...props }) => (
	<div {...props} className={cn('flex w-full rounded-2xl bg-white p-6 shadow-md md:w-[640px]! md:p-10!', className)}>
		{children}
	</div>
);

export const TopContentContainer = ({ children, className, ...props }) => (
	<div {...props} className={cn('mb-6 w-full md:mb-8! md:w-[640px]!', className)}>
		{children}
	</div>
);
